import { IHe } from "../../../model/respone/category/IHe";
import { eHeActionTypeIds } from "../../action-types/category/IHeActionType";
import { baseAction } from "../IActionBase";

export const heAction = {
    loadStart: () => baseAction(eHeActionTypeIds.LOAD_START, undefined),
    loadSuccess: (data: IHe[]) => baseAction(eHeActionTypeIds.LOAD_SUCCESS, data),
    loadError: (message?: string) => baseAction(eHeActionTypeIds.LOAD_ERROR, message),
}